import type { BranchMiniEntity } from '@/features/branch/domain/entities/BranchMiniEntity'

export class BranchPinFilterEntity {
  id?: number
  branch?: BranchMiniEntity
  page?: number
  limit?: number
  sortField?: string
  sortDescending?: boolean
}
